
import { mapGetters, mapState } from 'vuex';
import mixins from 'vue-typed-mixins';

import imageSizeMixin from '@/components/mixins/image-size';

export default mixins(imageSizeMixin).extend({
  name: 'UserWidgetBlock',
  computed: {
    ...mapGetters('user/profile', ['displayName', 'profileImage', 'hasPractice']),
    ...mapState('practices', ['userPractice']),
    ...mapGetters('practices', ['userPracticeIsLoaded']),
    sizedProfileImage(): string {
      return this.sizedUserProfileImage(this.profileImage);
    },
  },
});
